uniform vec3 uColor;
uniform float uBrightness;

varying float vAlpha;

void main()
{
  float dist = distance(gl_PointCoord, vec2(0.5));
  float strength = 0.05 / dist - 0.1;
  strength = clamp(strength, 0.0, 1.0);

  gl_FragColor = vec4(uColor, strength * vAlpha * uBrightness);
}
